import React from 'react';
import { CTAButton } from './CTAButton';
import { Sparkles, ShieldCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-20 md:py-32 px-4 bg-gradient-to-b from-orange-500 via-orange-600 to-amber-700 text-white text-center relative overflow-hidden" data-id="element-42">
      <div className="absolute inset-0 opacity-10" data-id="element-43">
        <div className="absolute top-10 left-10 w-40 h-40 bg-yellow-300 rounded-full blur-3xl" data-id="element-44" />
        <div className="absolute bottom-10 right-10 w-60 h-60 bg-orange-400 rounded-full blur-3xl" data-id="element-45" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-yellow-200 rounded-full blur-3xl" data-id="element-46" />
      </div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-47">
        {/* Guarantee */}
        <div className="bg-white/15 backdrop-blur-sm border border-white/20 rounded-2xl p-8 md:p-10 mb-14 max-w-2xl mx-auto" data-id="element-48">
          <div className="flex justify-center mb-4" data-id="element-49">
            <div className="bg-green-500 rounded-full p-3" data-id="element-50">
              <ShieldCheck className="w-10 h-10 text-white" data-id="element-51" />
            </div>
          </div>
          <h3 className="text-2xl md:text-3xl font-black mb-3 text-yellow-200 uppercase" data-id="element-52">
            Garantía de 7 días
          </h3>
          <p className="text-lg md:text-xl text-orange-100 leading-relaxed max-w-xl mx-auto" data-id="element-53">
            Si el material no cumple tus expectativas, te devolvemos el 100% de
            tu dinero. Sin preguntas, sin vueltas. Tu compra está protegida.
          </p>
        </div>

        {/* CTA */}
        <div className="flex justify-center mb-6" data-id="element-54">
          <Sparkles className="w-12 h-12 text-yellow-300 animate-pulse" data-id="element-55" />
        </div>
        <h2 className="text-4xl md:text-6xl font-black mb-6 uppercase tracking-tight leading-tight drop-shadow-lg" data-id="element-56">
          ¿Lista para dejar de improvisar?
        </h2>
        <p className="text-xl md:text-2xl font-medium mb-12 text-orange-100 max-w-2xl mx-auto" data-id="element-57">
          Accedé hoy al kit completo y empezá a trabajar con material
          profesional, organizado y listo para usar.
        </p>
        <CTAButton text="👉 QUIERO EMPEZAR AHORA" className="md:px-12 md:py-6 md:text-3xl" data-id="element-58" />
        <p className="mt-6 text-sm text-orange-200 font-medium" data-id="element-59">
          🔒 Pago seguro · Acceso inmediato por Drive · Garantía 7 días
        </p>
      </div>
    </section>;
}